import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useIntl } from "react-intl";
import { TableView } from "@gpstrackit/gtc-react-controls";

//Actions
import { ModalSearchUnits } from "./components/modalSearch";
import useLandmarkData from "Modules/dashboard/views/landmarkRealTime/hooks/useLandmarkRealTimeData";
import { createPortal } from 'react-dom';
import './landmarkRealTime.scss'
import { Icon } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MapModal from "Modules/.common/components/MapModal";
import { getLandmarksAndGeofences as getKmls } from 'Redux/actions';
import { endpoints } from "Core/defaultValues";
import { lastReadingSelectors } from 'Core/realtime/redux/lastReadingSlice';

const LandmarkRealTime = ({ item, update, changesFilters, setChangesFilters }) => {
  const { messages } = useIntl();
  const { total, data, moreRows, loading, handleChangePage, modalInformation, setModalInformation } = useLandmarkData(item, update, changesFilters, setChangesFilters);
  const [dataToMap, setDataToMap] = useState({});
  const readings = useSelector(state => lastReadingSelectors.selectAll(state));


  const portalRoot = document.querySelector('#portal-root');
  const jsonLandmark = useSelector((state) => state.catalogsRealtimeRedux.landmarks);
  const dispatch = useDispatch();
  const pathFile = `https://s3.amazonaws.com/${endpoints.PUBLIC_REPOSITORY_CODE}`

  useEffect(() => {
    dispatch(getKmls());
  }, []);

  const getIconLandmark = (item) => {
    const { landmark } = item;
    let url;
    if (landmark?.url) {
      url = `${pathFile}/${landmark?.url}`
    } else {
      if (landmark?.color) {
        url = `${pathFile}/kmls/flagicon/${landmark?.color}.png`;
      } else {
        url = `${pathFile}/kmls/flagicon/8677D9.png`
      }
    }
    return url;
  }

  const columns = [
    {
      key: 'landmark',
      title: messages['dashboardPanel_landmark'],
      show: true,
      export: true,
      render: (row) => (
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            if (!jsonLandmark.length || !readings.length) return;
            let pointerToMarker = row.deviceIds.map((item) => readings?.find((unit) => unit.deviceId == item.id));
            pointerToMarker = pointerToMarker.map((item) => {
              return {
                id: item.deviceId,
                latitude: item.latitude,
                longitude: item.longitude,
                direction: 35,
                heading: item.heading,
                Label: item.deviceLabel,
                eventName: item.eventName
              }
            });
            setDataToMap({
              show: true,
              landmark: jsonLandmark && jsonLandmark.find((item) => item.id == row?.landmark.landmarkId) || {},
              title: row?.landmark.landmarkName,
              pointers: [...pointerToMarker],
            })
          }}
        >
          <img src={getIconLandmark(row)} class="groupItem-icon" style={{ width: "20px", height: "20px" }} />
          <p style={{ textDecoration: "underline", cursor: "pointer" }}>
            <span style={{ padding: "0 5px 0 5px" }}>{row?.landmark.landmarkName}</span>
          </p>
        </div>
      ),
    },
    {
      key: 'visits',
      title: messages['dashboardPanel_Num_Vehicles'],
      show: true,
      export: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => {
            setModalInformation({
              open: true,
              label: row?.landmark.landmarkName,
              data: row.deviceIds,
            });
          }}
        >
          {`${row?.visits} ${messages['dashboardPanel_vehicle']}${row?.visits > 1 ? 's' : ''}`}
        </div>
      ),
    },
  ];

  return (
    <>
      <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <div style={{ flex: 1, minHeight: 0 }}>
          <TableView
            keyColumn="id"
            columns={columns}
            data={data}
            disableItemSelection
            infiniteScroll
            hideDragable
            inputSearch={false}
            loading={loading}
            moreRowsAvailable={moreRows}
            onChangePage={handleChangePage}
            noMoreItemsMessage={messages?.['noMoreItems'] || 'There are no more items'}
            rowsPerPage={25}
            total={total}
          />
        </div>
      </div>
      <div style={{ all: 'unset' }}>
        {createPortal(
          <MapModal
            hiddenButton
            {...dataToMap}
            hiddenTraffic={true}
            hiddenWeather={true}
            hiddenSearchMap={true}
            hideModal={() => {
              setDataToMap({ show: false })
            }}
            zoom={18}
          />,
          portalRoot
        )}
      </div>
      {createPortal(
        <ModalSearchUnits messages={messages} modalInformation={modalInformation} setModalInformation={setModalInformation} />,
        portalRoot
      )}
    </>
  );
};

export default LandmarkRealTime;
